// extracted by mini-css-extract-plugin
module.exports = {"dragDropWrapper":"Report_dragDropWrapper__6H3KI"};